'use es6';

import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const textKey = 'ecosystem-marketplace-solutions-ui.error.default';
const GenericError = () => {
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    "data-test-id": "error-state",
    title: unescapedText(`${textKey}.title`),
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${textKey}.body`
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: `${textKey}.cta_jsx`,
        options: {
          onRefresh: () => window.location.reload()
        },
        elements: {
          Link
        }
      })
    })]
  });
};
export default GenericError;